import roomies from "./api/roomies";
import mapbox from "./api/mapbox";

export default (includeAddresses) => {
  return mapbox;
};
